import { useState, useEffect } from "react";
import { PropTypes } from "base/react-libs";
import TaskNotificationBadge from "apps/tasks/task-notification-badge";

// THIS IS GOING TO BE DEPRECATED SOON
const JourneysNavButtonContent = ({ name, tasksDueCount }) => {
  const [count, setCount] = useState(tasksDueCount || 0);

  useEffect(() => {
    setCount(tasksDueCount);
  }, [tasksDueCount]);

  return (
    <div className="journeys-nav-button-containter">
      <div>{name}</div>
      <TaskNotificationBadge count={count} />
    </div>
  );
};

JourneysNavButtonContent.propTypes = {
  name: PropTypes.string,
  tasksDueCount: PropTypes.number,
};

export default JourneysNavButtonContent;
